import {  defineMessages } from 'react-intl'

const messages = defineMessages({
  cancel: {
    id: 'dialog.cancel',
    defaultMessage: 'cancel'
  },
  confirm: {
    id: 'dialog.yes',
    defaultMessage: 'yes'
  },
  create_notification: {
    id: 'dialog.create_notification',
    defaultMessage: 'Create notification'
  },
    create_note: {
    id: 'dialog.create_note',
    defaultMessage: 'Create note'
  },
  notification_edit: {
    id: 'dialog.notification_edit',
    defaultMessage: 'The notification has already been sent and can no longer be edited.'
  },
  send_to: {
    id: 'dialog.send_to',
    defaultMessage: 'Send to:'
  },
  enter_notification: {
    id: 'dialog.enter_notification',
    defaultMessage: 'Enter text for the notification'
  },
  enter_note: {
    id: 'dialog.enter_note',
    defaultMessage: 'Enter text for the note'
  },
  required_field: {
    id: 'dialog.required_field',
    defaultMessage: 'This field is required.'
  },
  me: {
    id: 'dialog.notification_me',
    defaultMessage: 'ME'
  },
  me_and_client: {
    id: 'dialog.notification_me_and_client',
    defaultMessage: 'ME AND CLIENT'
  },
  client: {
    id: 'dialog.notification_client',
    defaultMessage: 'CLIENT'
  },
  symbol_plus: {
    id: 'dialog.symbol_plus',
    defaultMessage: '+'
  },
  button_install_icon: {
    id: 'dialog.button_install_icon',
    defaultMessage: 'add'
  },
  add_wl_to_homescreen: {
    id: 'dialog.add_wl_to_homescreen',
    defaultMessage: '+ Add {name} Icon to Home Screen'
  },
  install_icon_instructions: {
    id: 'dialog.install_icon_instructions',
    defaultMessage: 'How to Install Icon on Home Screen?'
  },
  are_you_sure_you_want_to_archive_this_client: {
    id: 'dialog.are_you_sure_you_want_to_archive_this_client',
    defaultMessage: 'Are you sure you want to archive this client?'
  },
  if_your_client_is_archived_you_wont_be_able_to_view_content: {
    id:'dialog.if_your_client_is_archived_you_wont_be_able_to_view_content',
    defaultMessage: "If your client is archived, you won't be able to view content."
  },
  archive: {
    id: 'dialog.archive',
    defaultMessage: 'Archive'
  },
  archiving: {
    id: 'dialog.archiving',
    defaultMessage: 'Archiving'
  },
  to_manage_your_subscription_sign_in_here_with_your_credentials: {
    id: 'dialog.to_manage_your_subscription_sign_in_here_with_your_credentials',
    defaultMessage: 'To manage your subscription sign in here with your credentials.'
  },
  choose_unit_system: {
    id: 'nutrition_plan.choose_unit_system',
    defaultMessage: 'Choose unit system'
  },
  height: {
    id: 'height',
    defaultMessage: 'Height'
  },
  mass: {
    id: 'mass',
    defaultMessage: 'Mass'
  },
  volume: {
    id: 'volume',
    defaultMessage: 'Volume'
  },
  energetic_value: {
    id: 'energetic_value',
    defaultMessage: 'Energetic value'
  },
  speed: {
    id: 'speed',
    defaultMessage: 'Speed'
  },
  length: {
    id: 'length',
    defaultMessage: 'Length'
  },
  body_mass_index: {
    id: 'body_mass_index',
    defaultMessage: 'Body mass index'
  },
  entries_count_by_month: {
    id: 'dialog.entries_count_by_month',
    defaultMessage: 'Entries count by month'
  },
  weight: {
    id: 'workout.weight',
    defaultMessage: 'Weight'
  },
  pace: {
    id: 'pace',
    defaultMessage: 'Pace'
  },
  enable: {
    id: 'mfwnet.enable',
    defaultMessage: 'Enable'
  },
  disable: {
    id: 'mfwnet.disable',
    defaultMessage: 'Disable'
  },
  mfwnetpermission_text: {
    id: 'mfwnet.mfwnetpermission_text',
    defaultMessage: 'By enabling this feautre, you give your clients access to MFWNet - public section where all the trainers and/or gyms, fitness and sports clubs post their public (free) content.'
  },
  mfwnet_permission: {
    id: 'profile.mfwnet_permission',
    defaultMessage: 'MFWNet Permission'
  },
  marketplace_dialog_title: {
    id: 'marketplace.dialog.title',
    defaultMessage: 'Marketplace Info'
  },
  marketplace_dialog_content: {
    id: 'marketplace.dialog.content',
    defaultMessage: 'Buying Content is only available to Exercisers. You can only Preview Content. If you want to Buy Content, please register with different Account as an Exerciser (Free, Organization\'s Client, or a PREMIUM Account).'
  },
  marketplace_trainer_info: {
    id: 'marketplace.trainer.info',
    defaultMessage: 'Editing Content is not allowed on your Marketplace page. If you want to edit your Content, please go to your Content section.'
  },
  personal_data: {
    id: 'profile.personal_data',
    defaultMessage: 'Personal Data'
  },
  visible_anyone: {
    id: 'profile.visible_anyone',
    defaultMessage: "Visible to anyone"
  },
  pricing_scale: {
    id: 'profile.pricing_scale',
    defaultMessage: "Pricing Scale"
  },
  phone_numberHelper: {
    id: 'profile.phone_numberHelper',
    defaultMessage: "Valid phone number info example 648707111. Type without zero (0) and without spaces."
  },
  services_from: {
    id: 'profile.services_from',
    defaultMessage: "From"
  },
  services_info: {
    id: 'profile.services_info',
    defaultMessage: "If you do not enter a numeric value for pricing, the information will be displayed as N/A on yur public profile."
  },
  services_to: {
    id: 'profile.services_to',
    defaultMessage: "To"
  },
  live_services: {
    id: 'profile.live_services',
    defaultMessage: "Live Services"
  },
  online_services: {
    id: 'profile.online_services',
    defaultMessage: "Online Services"
  },
  nutrition_services: {
    id: 'profile.nutrition_services',
    defaultMessage: "Nutrition Services"
  },
  currency_services: {
    id: 'profile.currency_services',
    defaultMessage: "Currency"
  },
  profile_data: {
    id: 'profile.profile_data',
    defaultMessage: 'Profile Data'
  },
  about_me: {
    id: 'profile.about_me',
    defaultMessage: 'About Me'
  },
  expertise_about_me: {
    id: 'profile.expertise_about_me',
    defaultMessage: 'Expertise, About Me'
  },
  expertise: {
    id: 'profile.expertise',
    defaultMessage: 'Expertise'
  },
  profile_info: {
    id: 'profile.profile_info',
    defaultMessage: 'Profile Info'
  },
  add_location_links: {
    id: 'profile.add_location_links',
    defaultMessage: 'Add Location Links'
  },
  location_links: {
    id: 'profile.location_links',
    defaultMessage: 'Location Links'
  },
  new_invitation: {
    id: 'new_invitation',
    defaultMessage: 'New Invitation'
  },
  invitation_text: {
    id: 'invitation_text',
    defaultMessage: 'You have an invitation to join organization {organizationName} as {role}'
  },
  invitation_additional_text: {
    id: 'invitation_additional_text',
    defaultMessage: 'You will be archived in your current organization.'
  },
  reject: {
    id: 'reject',
    defaultMessage: 'Reject'
  },
  accept: {
    id: 'invitation.info_page.button_accept',
    defaultMessage: 'Accept'
  },
  active_clients: {
    id: 'active_clients',
    defaultMessage: 'Active Clients'
  },
  week_start_day: {
    id: 'dialog.week_start_day',
    defaultMessage: 'Week Start Day',
  },
  week_start_day_monday: {
    id: 'dialog.week_start_day_monday',
    defaultMessage: 'Monday',
  },
  week_start_day_sunday: {
    id: 'dialog.week_start_day_sunday',
    defaultMessage: 'Sunday',
  },
  stripe_myFitWorld_new_pricing_starts_from: {
    id: 'myFitWorld_pricing_starting',
    defaultMessage: 'New Pricing starts from 15.03.2026.'
  },
  stripe_myFitWorld_new_pricing_check_details: {
    id: 'stripe_myFitWorld_new_pricing_check_details',
    defaultMessage: 'Check details '
  },
  stripe_myFitWorld_pricing: {
    id: 'myFitWorld_pricing',
    defaultMessage: 'MyFitWorld PRICING'
  },
  stripe_myFitWorld_pricing_starting: {
    id: 'myFitWorld_pricing_starting',
    defaultMessage: 'Starting from 15.03.2026.'
  },
  stripe_myFitWorld_package: {
    id: 'stripe_myFitWorld_package',
    defaultMessage: 'STANDARD package:'
  },
  stripe_myFitWorld_no_clients: {
    id: 'stripe_myFitWorld_no_clients',
    defaultMessage: 'No. Clients'
  },
  stripe_myFitWorld_price: {
    id: 'stripe_myFitWorld_price',
    defaultMessage: 'Price'
  },
  stripe_myFitWorld_discount: {
    id: 'stripe_myFitWorld_discount',
    defaultMessage: 'Discount'
  },
  stripe_myFitWorld_price_1: {
    id: 'stripe_myFitWorld_price_1',
    defaultMessage: '7.49€/M**'
  },
  stripe_myFitWorld_price_2: {
    id: 'stripe_myFitWorld_price_2',
    defaultMessage: '7.49€ + €3.00/Kl/M**'
  },
  stripe_myFitWorld_price_3: {
    id: 'stripe_myFitWorld_price_3',
    defaultMessage: '6.74€ + €2.70/Kl/M**'
  },
  stripe_myFitWorld_price_4: {
    id: 'stripe_myFitWorld_price_4',
    defaultMessage: '5.99€ + €2.40/Kl/M**'
  },
  stripe_myFitWorld_price_5: {
    id: 'stripe_myFitWorld_price_5',
    defaultMessage: '5.24€ + €2.10/Kl/M**'
  },
  stripe_myFitWorld_price_6: {
    id: 'stripe_myFitWorld_price_6',
    defaultMessage: '3.75€ + €1.50/Kl/M**'
  },
  stripe_myFitWorld_price_7: {
    id: 'stripe_myFitWorld_price_7',
    defaultMessage: '4.12€ + €1.65/KL/M**'
  },
  stripe_myFitWorld_price_8: {
    id: 'stripe_myFitWorld_price_8',
    defaultMessage: '2.99€ + €1.20/KL/M**'
  },
  stripe_myFitWorld_rebrand_users: {
    id: 'stripe_myFitWorld_rebrand_users',
    defaultMessage: 'REBRAND users:'
  },
  stripe_myFitWorld_rebrand: {
    id: 'stripe_myFitWorld_rebrand',
    defaultMessage: 'REBRAND:'
  },
  stripe_myFitWorld_free: {
    id: 'stripe_myFitWorld_free',
    defaultMessage: 'FREE*'
  },
  stripe_myFitWorld_month: {
    id: 'stripe_myFitWorld_month',
    defaultMessage: 'Monthly'
  },
  stripe_myFitWorld_year: {
    id: 'stripe_myFitWorld_year',
    defaultMessage: 'Yearly'
  },
  stripe_myFitWorld_lifetime: {
    id: 'stripe_myFitWorld_lifetime',
    defaultMessage: 'Lifetime'
  },
  stripe_myFitWorld_info_text_1: {
    id: 'stripe_myFitWorld_info_text_1',
    defaultMessage: '* Free for 0–4 clients applies only to monthly rebrand subscribers.'
  },
  stripe_myFitWorld_info_text_2: {
    id: 'stripe_myFitWorld_info_text_2',
    defaultMessage: '** EUR/CL/M – monthly subscription per client.'
  },
  stripe_myFitWorld_need_help: {
    id: 'stripe_myFitWorld_need_help',
    defaultMessage: 'Need help with MyFitWorld subscriptions?'
  },
  stripe_myFitWorld_arrange_consultations: {
    id: 'stripe_myFitWorld_arrange_consultations',
    defaultMessage: 'Arrange free consultations '
  },
  stripe_myFitWorld_here_link: {
    id: 'stripe_myFitWorld_here_link',
    defaultMessage: 'HERE.'
  },
})

export default messages;
